var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7809 7.33867C22.7809 7.33867 22.566 5.82188 21.9043 5.15586C21.0664 4.2793 20.1297 4.275 19.7 4.22344C16.6234 4 12.0043 4 12.0043 4H11.9957C11.9957 4 7.37656 4 4.3 4.22344C3.87031 4.275 2.93359 4.2793 2.0957 5.15586C1.43398 5.82188 1.22344 7.33867 1.22344 7.33867C1.22344 7.33867 1 9.12188 1 10.9008V12.568C1 14.3469 1.21914 16.1301 1.21914 16.1301C1.21914 16.1301 1.43398 17.6469 2.09141 18.3129C2.9293 19.1895 4.0293 19.1594 4.51914 19.2539C6.28086 19.4215 12 19.473 12 19.473C12 19.473 16.6234 19.4645 19.7 19.2453C20.1297 19.1938 21.0664 19.1895 21.9043 18.3129C22.566 17.6469 22.7809 16.1301 22.7809 16.1301C22.7809 16.1301 23 14.3512 23 12.568V10.9008C23 9.12188 22.7809 7.33867 22.7809 7.33867ZM9.72695 14.5918V8.40859L15.6695 11.5109L9.72695 14.5918Z",
    fill: "#FF0302"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.986b00dfc57fe315a21f91ec1203aa8e.svg";
export { ForwardRef as ReactComponent };